<div class="upsell-footer">
    <div class="upsell-footer__container px-4 py-10 text-sm mx-auto text-center">
        <div class="upsell-footer__wrapper text-center">
            <div class="footer_line"></div>
            <p class="mb-4" [innerHTML]="footerText"></p>
            <div class="upsell-footer__links my-4 flex justify-center gap-3">
                <a *ngFor="let link of footerLinks" href="{{ link.page || link.link }}" title="{{ link.label }}" (click)="navigateToPageByGenericUrl(link.page || link.link, link.target || '_blank', link.options); $event.preventDefault()">{{ link.label }}</a>
            </div>
        </div>
    </div>
</div>